import Encoding from "../Typing/Encoding";

export default class ContextualBranchManager {
    public static getBranchFromUrlValue(urlValue: string) {
        return urlValue === 'master__latest' ? urlValue : Encoding.encode(urlValue);
    }

    public static getUrlValueFromBranch(encodedBranch: string) {
        return Encoding.decode(encodedBranch);
    }

    public static getSelectedBranch(key: string) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(key)) {
            const urlValue = urlParams.get(key) ?? '';
            return ContextualBranchManager.getBranchFromUrlValue(urlValue);
        }

        return window.localStorage.getItem(`env-switcher.${key}.branch`);
    }

    public static getSelectedVersion(key: string) {
        const urlParams = new URLSearchParams(window.location.search);
        const versionKey = `${key}Version`;
        if (urlParams.has(versionKey)) {
            return urlParams.get(versionKey);
        }

        return window.localStorage.getItem(`env-switcher.${key}.version`);
    }

    public static setSelectedBranch(encodedBranch: string, key: string) {
        return window.localStorage.setItem(`env-switcher.${key}.branch`, encodedBranch);
    }

    public static setSelectedVersion(version: string, key: string) {
        return window.localStorage.setItem(`env-switcher.${key}.version`, version);
    }

    public static replaceSelectionInUrl(encodedBranch: string, version: string, key: string) {
        const url = new URL(window.location.href);
        url.searchParams.set(key, ContextualBranchManager.getUrlValueFromBranch(encodedBranch));
        url.searchParams.set(`${key}Version`, version);
        window.history.replaceState(window.history.state, '', url);
    }
}
